module.exports = {
  language: 'Vietnamese',
  nationalityKay: 'vi-vn',
  personal: {
    purgePopupContent:
      'Xin lỗi, dữ liệu ứng dụng của bạn đã bị xóa do chính sách bảo mật, bạn có thể liên hệ với chúng tôi nếu bạn muốn đăng ký sớm'
  },
  login_maximum: {
    errorContent: 'Xin lỗi bạn đã đạt đến thời gian đăng nhập tối đa ngày hôm nay, vui lòng thử vào ngày hôm sau.'
  },
  noneSelectedText: 'Vui lòng chọn',
  multiselect: {
    deselect: 'Nhấn Enter để xóa',
    select: 'Nhấn Enter để chọn',
    selected: 'Đã chọn'
  },
  enter: ' đi vào',
  upload_failed: 'Tải lên không thành công, vui lòng thử lại',
  due_time: 'đến hạn',
  requirement: 'Yêu cầu',
  something_went_wrong_please_retry: 'Đã xảy ra sự cố, vui lòng thử lại.',
  valid_rediret_home_page_popup_content:
    "Đã xảy ra ngoại lệ đăng nhập. Bạn đang cố truy cập trang chủ [ {country} - {center} ] để đăng nhập phải không? Nếu có, vui lòng nhấp vào 'Xác nhận'; nếu không, vui lòng nhấp vào 'Hủy' để chọn lại.",
  invalid_rediret_home_page_popup_content: 'Đã xảy ra ngoại lệ đăng nhập, vui lòng chọn quốc gia và địa điểm để tiếp tục.',
  'Temporarily not available': 'Tạm thời không có sẵn',
  'Coming soon': 'Sắp có'
};
